import FilterGroup from '@/components/base/FilterGroup';
import { genres, regions, types, years } from '@/mocks/movies';

export interface CategoryFilters {
  type: string;
  region: string;
  year: string;
  genre: string;
}

interface FilterSidebarProps {
  filters: CategoryFilters;
  onChange: (key: keyof CategoryFilters, value: string) => void;
  onReset: () => void;
}

export default function FilterSidebar({ filters, onChange, onReset }: FilterSidebarProps) {
  return (
    <div className="flex flex-col gap-5 rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-primary-600" />
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          重置
        </button>
      </div>

      <FilterGroup title="类型" options={types} value={filters.type} onChange={(v) => onChange('type', v)} />
      <FilterGroup title="地区" options={regions} value={filters.region} onChange={(v) => onChange('region', v)} />
      <FilterGroup title="年份" options={years} value={filters.year} onChange={(v) => onChange('year', v)} />
      <FilterGroup title="题材" options={genres} value={filters.genre} onChange={(v) => onChange('genre', v)} />
    </div>
  );
}